export const teacherDetailStyle = ({
  breakpoints,
  functions: { pxToRem },
}) => ({
  borderRadius: pxToRem(16),
  background: "#fff",
  padding: `${pxToRem(24)}`,
  marginBottom: pxToRem(24),
  minHeight: pxToRem(500),

  [breakpoints.down("xxl")]: {
    rowGap: 2.5,
    flexDirection: "column",
  },

  [breakpoints.down("md")]: {
    rowGap: 2,
  },
});

export const titleStyle = ({ typography, functions: { pxToRem } }) => ({
  fontFamily: typography.lexendFont,
  fontSize: pxToRem(24),
  fontWeight: 600,
  lineHeight: 1.37,
  color: "#1a1a1a",
  letterSpacing: "-0.8px",
  textTransform: "uppercase",
  marginBottom: pxToRem(21),
});
